module.exports = __webpack_public_path__ + "static/media/smart.ef23d9fc.svg";